var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 464;
var h = 464;
var nm = "check  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Check 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    232.006,
                    232.291,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    360,
                    360,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 30,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -19.884,
                                                    -7.955
                                                ],
                                                [
                                                    -3.459,
                                                    9.339
                                                ],
                                                [
                                                    10.822,
                                                    -9.339
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 38.0000015477717,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -10.697,
                                                    1.357
                                                ],
                                                [
                                                    -3.584,
                                                    9.339
                                                ],
                                                [
                                                    10.697,
                                                    -9.339
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tm",
                        s: {
                            a: 0,
                            k: 0,
                            ix: 1
                        },
                        e: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 30,
                                    s: [
                                        0
                                    ]
                                },
                                {
                                    t: 38.0000015477717,
                                    s: [
                                        100
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        o: {
                            a: 0,
                            k: 0,
                            ix: 3
                        },
                        m: 1,
                        ix: 2,
                        nm: "Trim Paths 1",
                        mn: "ADBE Vector Filter - Trim",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 30,
                                    s: [
                                        0.321568638086,
                                        0.733333349228,
                                        0.466666668653,
                                        1
                                    ]
                                },
                                {
                                    t: 38.0000015477717,
                                    s: [
                                        0.933333396912,
                                        1,
                                        0.980392217636,
                                        1
                                    ]
                                }
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 5.25,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Check",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 29.0000011811942,
        op: 929.000037838946,
        st: 29.0000011811942,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Green dot 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    232,
                    231,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    148,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    360,
                    360,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -14.728,
                                        0
                                    ],
                                    [
                                        0,
                                        -14.728
                                    ],
                                    [
                                        14.728,
                                        0
                                    ],
                                    [
                                        0,
                                        14.728
                                    ]
                                ],
                                o: [
                                    [
                                        14.728,
                                        0
                                    ],
                                    [
                                        0,
                                        14.728
                                    ],
                                    [
                                        -14.728,
                                        0
                                    ],
                                    [
                                        0,
                                        -14.728
                                    ]
                                ],
                                v: [
                                    [
                                        148,
                                        -26.667
                                    ],
                                    [
                                        174.667,
                                        0
                                    ],
                                    [
                                        148,
                                        26.667
                                    ],
                                    [
                                        121.333,
                                        0
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tm",
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.993
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 15,
                                    s: [
                                        100
                                    ]
                                },
                                {
                                    t: 30.0000012219251,
                                    s: [
                                        0
                                    ]
                                }
                            ],
                            ix: 1
                        },
                        e: {
                            a: 0,
                            k: 100,
                            ix: 2
                        },
                        o: {
                            a: 0,
                            k: 270,
                            ix: 3
                        },
                        m: 1,
                        ix: 2,
                        nm: "Trim Paths 1",
                        mn: "ADBE Vector Filter - Trim",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.117647066712,
                                0.839215755463,
                                0.490196108818,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 5,
                            ix: 5
                        },
                        lc: 2,
                        lj: 1,
                        ml: 4,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.117647059262,
                                0.839215695858,
                                0.490196079016,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.906
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 29,
                                    s: [
                                        0
                                    ]
                                },
                                {
                                    t: 34.0000013848484,
                                    s: [
                                        100
                                    ]
                                }
                            ],
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Green",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 15.0000006109625,
        op: 915.000037268714,
        st: 15.0000006109625,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Light Green 2",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    232,
                    231,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    360,
                    360,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        -35.346
                                    ],
                                    [
                                        35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        35.346
                                    ]
                                ],
                                o: [
                                    [
                                        35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        35.346
                                    ],
                                    [
                                        -35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        -35.346
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -64
                                    ],
                                    [
                                        64,
                                        0
                                    ],
                                    [
                                        0,
                                        64
                                    ],
                                    [
                                        -64,
                                        0
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.933333337307,
                                1,
                                0.980392158031,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Light Green",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Check = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Check as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Check.json.es.js.map
